import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["panel", "url", "previewIcon", "previewImage", "previewFallback"]

  switch(event) {
    this.panelTargets.forEach((panel) => {
      panel.hidden = panel.dataset.value !== event.currentTarget.value
    })
    this.refresh()
  }

  color({ params: { hex } }) {
    this.element.style.setProperty("--icon-picker-color", hex)
  }

  ignore(event) {
    event.preventDefault()
  }

  refresh() {
    const source = this.element.querySelector(".icon-picker__tab .icon-picker__radio:checked")?.value
    const icon = this.element.querySelector("input[name='portfolio[icon]']:checked")
    const pension = this.element.querySelector("input[name='portfolio[pension_logo]']:checked")
    const url = this.urlTarget.value.trim()

    const showIcon = Boolean(source === "icon" && icon)
    const showPension = Boolean(source === "pension" && pension)
    const showImage = Boolean(source === "url" && url) || showPension

    if (showIcon) this.previewIconTarget.innerHTML = icon.nextElementSibling.innerHTML
    if (showPension) this.previewImageTarget.src = pension.nextElementSibling.querySelector("img").src
    else if (showImage) this.previewImageTarget.src = url

    this.previewIconTarget.hidden = !showIcon
    this.previewImageTarget.hidden = !showImage
    this.previewFallbackTarget.hidden = showIcon || showImage
  }
}
